;(function () {
    const ADD_TO_CART_SELECTOR = ".AddToCart"
    const VARIANT_SELECTOR = "product-card-variant-selector"
    const WARNING_CLASS = "warning"
    const WARNING_DURATION = 2000
    const mobileQuery = window.matchMedia("(max-width: 767px)")

    function suppressDefaultSelection() {
        document
            .querySelectorAll(
                `${VARIANT_SELECTOR}[data-has-explicit-variant="false"]`
            )
            .forEach((selector) => {
                selector
                    .querySelectorAll("[data-option-value].selected")
                    .forEach((el) => el.classList.remove("selected"))
            })
    }

    function isOptionSelected(elements) {
        return elements.some((el) =>
            el.tagName === "INPUT"
                ? el.checked
                : el.classList.contains("selected")
        )
    }

    function getUnselectedGroups(selector) {
        const optionTypes = new Set(
            Array.from(selector.querySelectorAll("[data-option-value]")).map(
                (el) => el.dataset.optionType
            )
        )

        const unselectedGroups = []

        optionTypes.forEach((optionType) => {
            const group = selector.querySelector(
                `[data-option-group="${optionType}"]`
            )
            if (group && group.offsetParent === null) return

            const elements = Array.from(
                selector.querySelectorAll(
                    `[data-option-value][data-option-type="${optionType}"]`
                )
            )
            if (!isOptionSelected(elements)) {
                unselectedGroups.push(group || selector)
            }
        })

        return unselectedGroups
    }

    function flashWarning(el) {
        el.classList.remove(WARNING_CLASS)
        void el.offsetWidth // force reflow so the shake restarts if already warning
        el.classList.add(WARNING_CLASS)

        clearTimeout(el._warningTimeout)
        el._warningTimeout = setTimeout(() => {
            el.classList.remove(WARNING_CLASS)
        }, WARNING_DURATION)
    }

    function getButtonLabelElement(button) {
        return (
            button.querySelector(".button-label") ||
            button.querySelector("span")
        )
    }

    function flashButtonLabel(button, unselectedCount) {
        const labelEl = getButtonLabelElement(button)
        if (!labelEl) return

        if (!labelEl._warningTimeout) {
            labelEl._originalLabel = labelEl.textContent
        }

        labelEl.textContent =
            button.dataset.selectLabel ||
            (unselectedCount > 1 ? "Select your sizes" : "Select a size")

        clearTimeout(labelEl._warningTimeout)
        labelEl._warningTimeout = setTimeout(() => {
            labelEl.textContent = labelEl._originalLabel
            labelEl._warningTimeout = null
        }, WARNING_DURATION)
    }

    function scrollSelectorIntoView(selector) {
        if (!mobileQuery.matches) return
        selector.scrollIntoView({ behavior: "smooth", block: "center" })
    }

    
    function flashBundleSizeWarning(productCard, selector) {
        const warningEl = productCard.querySelector(
            "[data-bundle-size-warning]"
        )
        if (!warningEl) return

        warningEl.classList.add("active")

        clearTimeout(warningEl._warningTimeout)
        warningEl._warningTimeout = setTimeout(() => {
            warningEl.classList.remove("active")
        }, WARNING_DURATION)
    }

    function handleAddToCartClick(event) {
        const button = event.target.closest(ADD_TO_CART_SELECTOR)
        if (!button) return

        const productCard = button.closest("product-card")
        const selector =
            productCard && productCard.querySelector(VARIANT_SELECTOR)
        if (!selector) return // eg. gift cards have no size/variant selector

        const unselectedGroups = getUnselectedGroups(selector)
        if (unselectedGroups.length === 0) return // fully selected — let the real add-to-cart handler run

        event.preventDefault()
        event.stopImmediatePropagation()

        flashWarning(button)
        scrollSelectorIntoView(selector)
        if (selector.dataset.bundle === "true" && mobileQuery.matches) {
            flashBundleSizeWarning(productCard, selector)
        } else {
            flashButtonLabel(button, unselectedGroups.length)
        }
        unselectedGroups.forEach(flashWarning)
    }

    function init() {
        suppressDefaultSelection()
        document.addEventListener("click", handleAddToCartClick, true)
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init)
    } else {
        init()
    }

    window.ProductVariantGuard = { suppressDefaultSelection, getUnselectedGroups }
})()
